<template>
    <div class="customer-role-manage-box">
        <div class="customer-role-condition-box">
            <el-form :inline="true" :model="condition" size="small">
                <el-form-item label="角色名称">
                    <el-input class="customer-role-condition-box-label" v-model.trim="condition.name"
                              placeholder="角色名称"></el-input>
                </el-form-item>
                <el-form-item label="角色类型">
                    <el-select class="customer-role-condition-box-label" v-model="condition.type" placeholder="角色类型">
                        <el-option label="系统" :value="0"></el-option>
                        <el-option label="用户" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="启用状态">
                    <el-select class="customer-role-condition-box-label" v-model="condition.enabled" placeholder="启用状态">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="停用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="fetchData()" size="small">查找</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="div-hr"></div>
        <div class="op-box">
            <el-button size="small" icon="el-icon-plus" type="primary" @click="add" style="border-radius: 20px">添加
            </el-button>
            <el-button size="small" type="text" @click="edit"><i>
                <svg-icon style="width:1.2em; height: 1.2em" icon-class="修改"></svg-icon>
            </i>&nbsp;修改
            </el-button>
            <el-button size="small" type="text" @click="setMenu" style="color: #f8ae35"><i>
                <svg-icon style="width:1.2em; height: 1.2em;" color="#f8ae35" icon-class="修改"></svg-icon>
            </i>&nbsp;设置菜单权限
            </el-button>
            <el-button size="small" type="text" @click="getWarningType" style="color: #E88678"><i>
                <svg-icon style="width:1.2em; height: 1.2em;" color="#E88678" icon-class="修改"></svg-icon>
            </i>&nbsp;设置报警接收类型
            </el-button>
            <el-button size="small" type="text" @click="disable" style="color: #f1521b"><i>
                <svg-icon style="width:1.2em; height: 1.2em" icon-class="停用"></svg-icon>
            </i>&nbsp;停用
            </el-button>
        </div>
        <flex>
            <el-table class="customer-role-table" size="small" stripe
                      :data="customerRoles.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                      height="100%" width="100%"
                      highlight-current-row
                      :header-row-style="{color:'black'}"
                      @row-click="currClick">

                <el-table-column
                        prop="name"
                        align="center"
                        label="角色名称">
                </el-table-column>
                <el-table-column
                        prop="code"
                        align="center"
                        label="角色代码">
                </el-table-column>
                <el-table-column
                        prop="type"
                        align="center"
                        label="角色类型">
                    <template slot-scope="scope">
                        <span>{{ scope.row.type === 0 ? '系统': '用户' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="smsAuthStatus"
                        prop="smsAuth"
                        align="center"
                        label="短信认证">
                    <template slot-scope="scope">
                        <span>{{ scope.row.smsAuth === 1 ? '启用': '禁用' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="enabled"
                        align="center"
                        label="启用状态">
                    <template slot-scope="scope">
                        <span>{{ scope.row.enabled === 1 ? '启用': '停用' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="grade"
                        align="center"
                        label="角色级别">
                </el-table-column>
            </el-table>
        </flex>
        <div class="customer-role-page-box">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
            </el-pagination>
        </div>

        <el-dialog
                :visible.sync="dialogVisible"
                width="28.125rem"
                top="15vh"
                size="small"
        >
            <template slot="title">
                {{ typeof currCustomerRole.id === 'undefined' || currCustomerRole.id === null || currCustomerRole.id ===
                '' ? '添加': '编辑'}}角色
            </template>

            <div style="display: flex; justify-content: center">
                <el-form ref="form" :model="currCustomerRole" :rules="rules" label-width="5.5rem" size="small">
                    <el-form-item label="角色名称" prop="name">
                        <el-input v-model="currCustomerRole.name"
                                  @blur="currCustomerRole.name = currCustomerRole.name.replace(/\s/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="角色代码" prop="code">
                        <el-input v-model="currCustomerRole.code"></el-input>
                    </el-form-item>
                    <el-form-item label="角色类型">
                        <el-select v-model="currCustomerRole.type" placeholder="角色类型">
                            <el-option label="系统" :value="0"></el-option>
                            <el-option label="用户" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色级别" prop="grade">
                        <el-input-number v-model="currCustomerRole.grade" :min="0" :max="1000"
                                         :precision="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="短信认证" v-if="smsAuthStatus">
                        <el-select v-model="currCustomerRole.smsAuth" placeholder="短信认证">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="启用状态">
                        <el-select v-model="currCustomerRole.enabled" placeholder="启用状态">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="停用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="save" size="small">保存</el-button>
      </span>
        </el-dialog>

        <el-dialog
                :visible.sync="treeVisible"
                width="21.875rem"
                title="设置菜单权限"
        >
            <el-tree
                    :data="menuTree"
                    node-key="id"
                    :props="treeProps"
                    show-checkbox
                    ref="tree"
                    highlight-current
            >

            </el-tree>

            <span slot="footer" class="dialog-footer">
        <el-button @click="treeVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveMenu" size="small">保存</el-button>
      </span>
        </el-dialog>

        <el-dialog
                :visible.sync="warningTypeVisible"
                width="21.875rem"
                title="设置报警接收类型"
        >
            <el-tree
                    :data="warningTypeTree"
                    node-key="id"
                    :props="treeProps"
                    show-checkbox
                    ref="warningTree"
                    highlight-current
            >

            </el-tree>

            <span slot="footer" class="dialog-footer">
        <el-button @click="warningTypeVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveWarningType" size="small">保存</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
  import {getCustomerRoles, saveCustomerRole, verifyCustomerRole} from '@/api/customerRole'
  import {selectWarningRecordType, saveWarningType,selectRoleWarningType} from '@/api/WarningRecord'
  import {getMenuTree} from '@/api/customerMenu'
  import {getMenuIds, saveWithMenuIds} from '@/api/customerRoleMenu'
  import {getCurrDayZero, getCurrDayLast, formatToSecond} from '@/utils/time'
  import {mapGetters} from 'vuex'
  import {Message, MessageBox} from 'element-ui'
  import {identifierRegex} from '@/utils/validate'
  import Flex from '@/components/Flex'
  import {balance} from '@/config/config'

  export default {
    name: 'RoleManage',
    components: {
      'flex': Flex
    },
    data() {
      return {
        pickerOptions: {},
        currentPage: 1,
        pagesize: 10,
        pageTotal: 0,
        chooseTimes: [new Date(getCurrDayZero()), new Date(getCurrDayLast())],
        customerRoles: [],
        condition: {
          customerId: null,
          name: null,
          enabled: 1,
          type: 0
        },
        // 添加编辑
        currCustomerRole: {},
        dialogVisible: false,
        rules: {
          name: [{required: true, message: '角色名称必填', trigger: 'blur'}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }],
          code: [{required: true, pattern: identifierRegex, message: '请输入正确的角色代码', trigger: 'blur'}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }],
          grade: [{required: true, message: '角色级别必填', trigger: 'blur'}]
        },
        // 设置菜单权限
        treeVisible: false,
        warningTypeVisible: false,
        warningKeys:[],
        warningTypeTree: [],
        menuTree: [],
        menuIds: [],
        treeProps: {
          children: 'children',
          label: 'name'
        },
        smsAuthStatus: true
      }
    },
    computed: {
      ...mapGetters([
        'customerId'
      ]),
    },
    mounted() {
      this.fetchData()
      this.fetchMenuTree()
    },
    methods: {
      fetchData: function (isPage) {
        if (this.condition.name !== null && this.condition.name.length === 0) {
          this.condition.name = null
        }
        if (!isPage) {
          this.currentPage = 1
        }
        this.condition.customerId = this.customerId
        getCustomerRoles(this.condition).then(res => {
          if (res.code === 200) {
            this.customerRoles = res.infoJson
            this.currentPage=1
            this.pageTotal=this.customerRoles.length
            // 显示或隐藏短信二次验证设置
            if (this.condition.type === 0) {
              this.smsAuthStatus = true
            } else {
              this.smsAuthStatus = false
            }
          }
        }).catch(error => {
        })
      },
      fetchMenuTree: function () {
        getMenuTree(this.customerId).then(res => {
          if (res.code === 200) {
            this.menuTree = res.infoJson
          }
        })
      },
      fetchMenuIds: function () {
        getMenuIds(this.currCustomerRole.id).then(res => {
          if (res.code === 200) {
            this.menuIds = res.infoJson
            this.$refs.tree.setCheckedKeys([])
            this.menuIds.forEach(menuId => {
              this.$refs.tree.setChecked(menuId, true)
            })
          }
        })
      },
      saveMenu: function () {
        this.menuIds = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
        saveWithMenuIds(this.currCustomerRole.id, this.menuIds).then(res => {
          if (res.code === 200) {
            if (res.code === 200) {
              Message({
                message: '操作成功',
                type: 'success',
                duration: 5 * 1000
              })
            } else {
              Message({
                message: '操作失败',
                type: 'error',
                duration: 5 * 1000
              })
            }
          }
          this.treeVisible = false
        })
      },
      getWarningType() {

        if (typeof this.currCustomerRole.id === 'undefined' || this.currCustomerRole.id === null || this.currCustomerRole.id === '') {
          Message({
            message: '请选择角色',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        this.warningKeys = []
        this.warningTypeTree = []
        this.warningTypeVisible = true
        if(this.currCustomerRole.type + '' === '1')
        {
          this.warningTypeTree = []
          this.warningTypeTree.push({name:'余额不足报警',id:balance})
          selectRoleWarningType(this.currCustomerRole.id).then(response =>{
            if(response.code === 200)
            {
              const data = response.infoJson
              /*  for (let i in data)
                {
                  this.warningKeys.push(data[i].warningTypeId)
                }*/
              console.log(this)
              this.$refs.warningTree.setCheckedKeys([])
              data.forEach(d => {
                this.$refs.warningTree.setChecked(d.warningTypeId, true)
              })

              console.log(data);
              console.log(this.warningKeys);
            }
          })
        }

          else{
          selectWarningRecordType(this.customerId).then(response => {
            if (response.code === 200 && response.infoJson != null) {
              this.warningTypeTree = response.infoJson
              console.log(this.warningTypeTree)
              selectRoleWarningType(this.currCustomerRole.id).then(response =>{
                if(response.code === 200)
                {
                  const data = response.infoJson
                /*  for (let i in data)
                  {
                    this.warningKeys.push(data[i].warningTypeId)
                  }*/
                  console.log(this)
                  this.$refs.warningTree.setCheckedKeys([])
                  data.forEach(d => {
                    this.$refs.warningTree.setChecked(d.warningTypeId, true)
                  })

                  console.log(data);
                  console.log(this.warningKeys);
                }
              })

            }
            else {
              Message({
                message: '查询报警类型失败',
                type: 'error',
                duration: 5 * 1000
              })
            }

          }).catch(error => {
            Message({
              message: '查询报警类型失败',
              type: 'error',
              duration: 5 * 1000
            })
          })
        }

      }, saveWarningType() {
        const customerRoleIds = this.$refs.warningTree.getCheckedKeys().concat(this.$refs.warningTree.getHalfCheckedKeys())
        saveWarningType(this.currCustomerRole.id, customerRoleIds).then(response => {
          if(response.code === 200)
          {
            Message({
              message: '操作成功',
              type: 'success',
              duration: 5 * 1000
            })

          }
          else
            Message({
              message: '操作失败',
              type: 'error',
              duration: 5 * 1000
            })
            this.warningTypeVisible = false
        }).catch(error=>{
          console.log(error)
          Message({
            message: '操作失败',
            type: 'error',
            duration: 5 * 1000
          })
        })
      },
      setMenu: function () {
        if (typeof this.currCustomerRole.id === 'undefined' || this.currCustomerRole.id === null || this.currCustomerRole.id === '') {
          Message({
            message: '请选择角色',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        this.treeVisible = true
        this.fetchMenuIds()
      },
      formatTime: function (time) {
        if (typeof time !== 'undefined' && time !== null) {
          return formatToSecond(time)
        } else {
          return time
        }
      },
      handleSizeChange: function (size) {
        this.pagesize = size
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage
      },
      currClick: function (val) {
        this.currCustomerRole = Object.assign({}, val)
      },
      edit: function () {
        if (typeof this.currCustomerRole.id === 'undefined' || this.currCustomerRole.id === null || this.currCustomerRole.id === '') {
          Message({
            message: '请选择角色',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      add: function () {
        // this.currCustomerRole.id = null
        this.currCustomerRole = {type: 0, grade: 0, enabled: 1, smsAuth: 0, customerId: this.customerId, createDate: new Date()}
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      save: function () {
        this.$refs.form.validate(valid => {
          if (valid) {
            verifyCustomerRole(this.currCustomerRole).then(res => {
              if (res.code === 200) {
                if (res.infoJson === true) {
                  saveCustomerRole(this.currCustomerRole).then(res => {
                    if (res.code === 200) {
                      Message({
                        message: '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                      })
                      this.dialogVisible = false
                      this.currCustomerRole = {id: null}
                      this.fetchData(true)
                    } else {
                      Message({
                        message: '操作失败',
                        type: 'error',
                        duration: 5 * 1000
                      })
                    }
                  })
                } else {
                  Message({
                    message: '该角色已存在',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                }
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      disable: function () {
        if (typeof this.currCustomerRole.id === 'undefined' || this.currCustomerRole.id === null || this.currCustomerRole.id === '') {
          Message({
            message: '请选择角色',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        const customerRole = {
          id: this.currCustomerRole.id,
          enabled: 0
        }

        MessageBox.confirm('确定停用该角色？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          saveCustomerRole(customerRole).then(res => {
            if (res.code === 200) {
              Message({
                message: '操作成功',
                type: 'success',
                duration: 5 * 1000
              })
              this.currCustomerRole = {id: null}
            } else {
              Message({
                message: '操作失败',
                type: 'error',
                duration: 5 * 1000
              })
            }
            this.fetchData()
          })
        })
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .customer-role-manage-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;

        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }

        .customer-role-condition-box {
            font-size: 14px;
            height: 60px;
            display: flex;
            align-items: center;
            padding-top: 15px;
            padding-left: 20px;
            box-sizing: border-box;
            .customer-role-condition-box-label {
                width: 120px;
            }
            .customer-role-search-button {
                margin-left: 10px;
            }
        }

        .op-box {
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;

            button {
                margin-right: 20px;
            }
        }
        .div-hr {
            height: 1px;
            background-color: #dedede;
        }
        .customer-role-page-box {
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-tree {
            background: #f6f7f7 !important;
        }

    }
</style>

<style>
    .el-table th {
        background-color: #f5fafb;
    }

    .el-table__row--striped {
        background-color: #f4f3f3 !important;
    }
</style>
